import * as React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import MaintenanceGate from './components/MaintenanceGate';
import reportWebVitals from './reportWebVitals';
import AppTheme from './shared-theme/AppTheme'; // Import AppTheme
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppTheme>
      <MaintenanceGate>
        <App />
      </MaintenanceGate>
    </AppTheme>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();